// import { getWorkers } from '@/api/open'

export default {
    components: {},
    props: {
        showJumpJuliangPage: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            labelCol: {span: 4},
            wrapperCol: {span: 18},
            roles: [],
            corporations: [],
            loading: false,
            rules: {
                worker_id: [{required: true, message: '请选择优化师', trigger: 'change'}],
            },
            workers: [],
            admins:[],
            refresh: false,
        }
    },
    computed: {
        actType() {
            return '选择巨量邮箱（需安装谷歌浏览器插件才能自动登录）'
        }
    },
    mounted() {
        // console.log('this.model', this.model)
        //如果只有一个邮箱，直接跳转
        if (this.model.emails && this.model.emails.length <= 1) {
            this.close()
            this.autoLoginJuliang(this.model.emails[0].name, this.model.emails[0].cookie)
        }
    },
    methods: {
        close() {
            this.$emit('update:showJumpJuliangPage', false)
        },
        autoLoginJuliang2(email, encryptedCookies){
            //  let encryptedCookies = ''
            this.close()
            let url = this.model.url
            try {
                if (encryptedCookies) {
                    console.log('开始调用插件，执行自动登录', )
                    const data = {
                        action: 'playletAutoLoginJuliang',
                        cookie: encryptedCookies,
                        jumpUrl: url
                    };
                
                    // 使用 window.postMessage 向插件传递数据
                    window.postMessage(data, '*');  // 向所有窗口发送数据，* 表示所有源都可以接收
                }
            
            } catch (error) {
                // window.open(url, '_blank');
            }

            window.open(url, '_blank');


            // 监听返回消息
            window.addEventListener('message', function(event) {
                // 验证消息来源，确保安全
                // if (event.origin !== 'https://example.com') {
                //     // return;
                // }
            
                const responseData = event.data;
                if (responseData && responseData.status === 'ok') {
                    console.log('插件处理完成，返回数据:', responseData);
                    // 在这里处理返回的数据
                } 
            });

        },
        autoLoginJuliang(email = null, encryptedCookies = null) {
            this.close();
            const url = this.model.url;
            if (!email || !encryptedCookies) {
                //直接跳转
               window.open(url, '_blank');
               return;
            }

            let hasJumped = false;
        
            const handleMessage = (event) => {
                const responseData = event.data;
                if (responseData && responseData.status === 'ok') {
                    console.log('插件处理完成，返回数据:', responseData);
        
                    if (!hasJumped) {
                        hasJumped = true;
                        const win = window.open(url, '_blank');
                        // 可选刷新（如果目标页需要强刷）
                        win.onload = function () {
                            win.location.reload();
                        };
                    }
                }
            };
        
            window.addEventListener('message', handleMessage, { once: true });
        
            try {
                if (encryptedCookies) {
                    console.log('开始调用插件，执行自动登录');
                    const data = {
                        action: 'playletAutoLoginJuliang',
                        cookie: encryptedCookies,
                        jumpUrl: url
                    };
                    window.postMessage(data, '*');
                }
            } catch (error) {
                console.error('调用插件失败', error);
                if (!hasJumped) {
                    hasJumped = true;
                    window.open(url, '_blank');
                }
            }
        
            // 超时兜底：插件没响应就跳转
            setTimeout(() => {
                window.removeEventListener('message', handleMessage);
                if (!hasJumped) {
                    hasJumped = true;
                    window.open(url, '_blank');
                }
            }, 600);
        }
        
    }
}
